var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoil2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1209_60)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1209_60)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.0001,
    cy: 15.0001,
    r: 13.9583,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.04175 14.9167V21.8889H14.9306H23.8195V14.9167V7.91669L22.6529 8.13892C21.9862 8.25003 20.9029 8.33336 20.2084 8.30558C19.514 8.2778 18.3751 8.25003 17.6529 8.25003C16.9029 8.25003 15.7084 8.25003 14.9306 8.25003C14.1806 8.25003 12.9584 8.25003 12.2362 8.25003C11.4862 8.25003 10.3473 8.2778 9.65286 8.30558C8.95841 8.33336 7.87508 8.25003 7.23619 8.13892L6.04175 7.91669V14.9167ZM9.65286 9.44447C10.3473 9.38892 11.4862 9.36114 12.2362 9.36114C12.9584 9.36114 14.1806 9.36114 14.9306 9.36114C15.7084 9.36114 16.9029 9.36114 17.6529 9.36114C18.3751 9.36114 19.514 9.38892 20.2084 9.44447C20.9029 9.50003 21.7362 9.41669 22.0973 9.30558C22.6529 9.08336 22.7084 9.13892 22.7084 10.1945V11.3334H14.9306H7.15286V10.1945C7.15286 9.13892 7.20841 9.08336 7.79175 9.30558C8.12508 9.41669 8.95841 9.50003 9.65286 9.44447ZM10.9029 12.8889C11.1806 13.3056 11.264 13.3056 11.6529 12.8889C12.3195 12.2222 17.2917 12.25 17.5417 12.8889C17.7084 13.3334 17.764 13.3334 18.2084 12.8889C18.5973 12.5556 19.264 12.4445 20.7084 12.4445H22.7084V14.1111V15.7778H19.9306C17.7084 15.7778 17.0973 15.6945 16.9862 15.3611C16.8751 15.1389 16.6529 14.9445 16.4306 14.9445C16.2084 14.9445 16.0417 15.1389 16.0417 15.3611C16.0417 15.6945 15.6251 15.7778 13.9584 15.7778C12.2917 15.7778 11.8751 15.6945 11.8751 15.3611C11.8751 15.1389 11.6806 14.9445 11.4584 14.9445C11.2084 14.9445 10.9584 15.1389 10.8751 15.3611C10.7362 15.6667 10.264 15.7778 8.93064 15.7778H7.15286V14.1111V12.4445H8.8473C10.0973 12.4445 10.6529 12.5556 10.9029 12.8889ZM22.7084 17.7222V18.5556H14.9306H7.15286V17.7222V16.8889H14.9306H22.7084V17.7222ZM22.7084 20.2222V21.0556H14.9306H7.15286V20.2222V19.3889H14.9306H22.7084V20.2222Z",
    fill: "#32CD32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87511 14.0001C8.98622 14.5834 9.48622 14.6389 9.59733 14.0278C9.65289 13.7501 9.514 13.5556 9.23622 13.5556C8.95844 13.5556 8.81955 13.7223 8.87511 14.0001Z",
    fill: "#32CD32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.014 13.7222C13.764 14 14.0695 14.3889 14.5418 14.3889C14.764 14.3889 14.9307 14.1945 14.9307 13.9722C14.9307 13.5556 14.3473 13.3889 14.014 13.7222Z",
    fill: "#32CD32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9862 14.0001C20.0973 14.5834 20.5973 14.6389 20.7084 14.0278C20.764 13.7501 20.6251 13.5556 20.3473 13.5556C20.0695 13.5556 19.9306 13.7223 19.9862 14.0001Z",
    fill: "#32CD32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1209_60",
    x: -0.958252,
    y: -0.958252,
    width: 31.9167,
    height: 31.9167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1209_60"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1209_60",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1209_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoil2);
export default __webpack_public_path__ + "static/media/soil-_2_.1d3a15c5a2d07ab9f692a2fdfce9ef4d.svg";
export { ForwardRef as ReactComponent };